export default {
	SET_CONTENT: 'SET_CONTENT',
	SET_OPENED: 'SET_OPENED'
}
